<template>
  <div class="container">
    <h1>Page is not found</h1>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  text-align: center;
}
</style>